import { Extra } from '../../api/types';
import { Flow } from '../../types/appLogic';
import { Status } from './slicesTypes';

export enum StackName {
  ultra17 = 'ultra-17',
  ultra18 = 'ultra-18',

  bhPost10 = 'bh-post-10',
  laundryPost10 = 'laundry-post-10',

  bhTerminalPure = 'bh-terminal-pure',
  laundryTerminalPure = 'laundry-terminal-pure',

  loundry2 = 'loundry2',
  bhLaundry = 'bh_laundry',

  bhScreenDb = 'bh-screen-db',
  bhScreenDbQpro = 'bh-screen-db-qpro',
}

export interface Cell {
  cell: number;
  width: number;
  height: number;
  depth: number;
  screen: boolean;
  row: number;
}

export interface Stack {
  name: StackName;
  stack: number;
  width: number;
  height: number;
  depth: number;
  cells: Cell[];
}

export interface ConfigResponse {
  device: string;
  stacks: Stack[];
}

export interface OpenCellArg {
  deviceUid: string;
  orderUid: string;
  flow: Flow;
}

export interface InitialState {
  openedCellData: Extra | null;
  configStatus: Status;
  openingStatus: Status;
  config: null | ConfigResponse;
}
